export default "__VITE_ASSET__BM50D$3U__"